module.exports = __webpack_public_path__ + "sideSprite-3ba6d2a11774b96d26e41622a5e453bd.png";